// extracted by mini-css-extract-plugin
module.exports = {"container":"NumberInput_container__2J-UX"};